interface ReadCookieOptions {
  name: string;
  env: string;
}

export const readCookie = (options: ReadCookieOptions) => {
  const { name, env } = options;

  if (typeof document === "undefined" || !document.cookie) return undefined;

  const cookies = document.cookie.split("; ");
  const matchingCookies = cookies.filter((cookie) =>
    cookie.startsWith(`${name}=`),
  );

  if (matchingCookies.length === 0) return undefined;

  // Because we can't be sure that there is only one cookie with the name we are looking for (e.g. due to different subdomains for production and staging), we need to check all cookies with this name and return the one with the correct environment ("env") value
  for (const cookie of matchingCookies) {
    try {
      const encodedValue = cookie.slice(cookie.indexOf("=") + 1);
      if (!encodedValue) continue;

      const decodedValue = decodeURIComponent(encodedValue);
      const cookieData = JSON.parse(decodedValue);

      if (cookieData.env !== env) continue;

      return cookieData;
    } catch {
      continue;
    }
  }

  return undefined;
};
